import { IBaseResponse } from "@nkr/models/base-response";
import { IAccountsPayableOpo, IAccountsPayableOpoDetail } from "@nkr/models/reports";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api/useAppHookContext";
import { useEffect, useState } from "react";
import * as moment from 'moment';

interface IRetVal {
    list: IAccountsPayableOpoDetail[],
    loading: boolean,
    error: string,
    isPayable: boolean
}

function useOpoDetails(ap: IAccountsPayableOpo, show: boolean): IRetVal {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IAccountsPayableOpoDetail[]>([]);

    const isPayable = ap.confirmationAmount != null
        && ap.confirmationAmount === ap.payNow
        && !!ap.confirmationNumber;

    useEffect(() => {
        if (ap && show) {
            setLoading(true);
            setError('');

            const fetchData = async () => {
                const config = {
                    url: `${__API_BASE_}/admin/billing-report/accounts-payable-opo/${ap.opoId}`
                };

                try {
                    const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(config));

                    if (response && response.data.results && response.data.success) {
                        const currentYear = moment().year();
                        const currentSemNum = moment().month() < 6 ? 1 : 2;
                        const payable = (response.data.results as IAccountsPayableOpoDetail[]).filter(item => {
                            const d = moment(item.invoiceDate);
                            return !(d.year() === currentYear && (d.month() < 6 ? 1 : 2) === currentSemNum);
                        });
                        setList(payable);
                    } else {
                        setError('Unable to load data');
                        setList([]);
                    }
                } catch (err) {
                    setList([]);
                    setError(err);
                } finally {
                    setLoading(false);
                }
            };

            fetchData();
        }
    }, [ap, show]);

    return { list, loading, error, isPayable };
}

export default useOpoDetails;
